import React, { useEffect, useMemo, useState } from 'react'
import CommonLayout from '../../../layouts/Common'
import { CommunityCard, CommunityTag, DivWrapper, FilterActionsWrapper, NoDataWrapper, PopOverItem, PopOverWrapper } from './style'
import { Avatar, Checkbox, CheckboxOptionType, Divider, Flex, GetProp, Image, Modal, Pagination, PaginationProps, Popover, Select, Spin } from 'antd'
import { StyledButton } from '../../../components/Common/Button/style'
import MaterialIcon from '../../../components/Icons/MaterialIcon'
import { theme } from '../../../styles/theme'
import useTags from '../../../hooks/common/useTags'
import { CommunitySubGroupType, ForumTopicType, TagsType } from '../../../types'
import useListAllForumTopics from '../../../hooks/common/useForums'
import CustomLoading from '../../../components/Common/Loading'
import { AvatarContainer } from '../../../layouts/Common/style'
import imgPlaceholder from '../../../assets/images/img-placeholder.png'
import { getRandomAvatarUrl } from '../../../helpers'
import CommunityForm from '../../../components/Forms/Community'
import { useNavigate } from 'react-router-dom'
import useListCommunitySubgroups from '../../../hooks/admin/useCommunitySubgroups'

type ForumFilter = {
  tags?: string | null
  authors?: string[] | null
  pilotGroupIds?: string[] | null
  categories?: string[] | null
}

const ProfessionalCommunity = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [forumsPerPage, setForumsPerPage] = useState(10);
  const [tagsPerPage, setTagsPerPage] = useState(100);
  const [filter, setFilter] = useState<ForumFilter>({
    tags: null,
    authors: null,
    pilotGroupIds: null,
    categories: null
  });
  const { data: tags, total: totalTags, loading: loadingTags, refetch: refetchTags } = useTags(1, tagsPerPage);
  const { data: forums, total: totalForums, loading: loadingForums, refetch: refetchForums } = useListAllForumTopics(currentPage, forumsPerPage, filter);
  const { data: communitySubgroups, loading: loadingListCommunitySubgroups } = useListCommunitySubgroups(1 as number, 100);
  const [modal, setModal] = useState({
    newForum: {
      open: false,
      title: 'New Forum Post'
    }
  });

  const authorsOptions: CheckboxOptionType[] = useMemo(() => {
    const uniqueOwners = Array.from(
      new Set(
        forums?.map((forum: ForumTopicType) => forum.attributes.owner)
      )
    ).map((owner) => ({
      label: owner as string,
      value: owner as string
    }));

    return uniqueOwners;
  }, [forums]);

  const communitySubgroupsOptions: CheckboxOptionType[] = useMemo(() => {
    const uniqueSubgroups = communitySubgroups?.map((subgroup: CommunitySubGroupType) => ({
      label: subgroup?.attributes?.name,
      value: subgroup.id
    }));
    console.log('uniqueSubgroups', uniqueSubgroups)

    return uniqueSubgroups;
  }, [communitySubgroups]);

  const categoriesOptions: CheckboxOptionType[] = [
    {
      label: 'IDEA',
      value: 'idea'
    },
    {
      label: 'SUCCESS STORY',
      value: 'success_story'
    },
    {
      label: 'QUESTION',
      value: 'question'
    },
  ];

  const options = tags?.map((tag: TagsType) => ({
    label: tag.name,
    value: tag.id
  }));

  const onCheckAll = (type: string) => {
    let allData: any[] = [];
    switch (type) {
      case 'authors':
        allData = authorsOptions.map((author) => author.label);
        break;
      case 'tags':
        allData = options.map((tag: any) => tag.id);
        break;
      case 'pilotGroupIds':
        allData = communitySubgroupsOptions.map((subgroup) => subgroup.value);
        break;
      case 'categories':
        allData = categoriesOptions.map((category) => category.value);
        break;
      default:
    }

    setFilter((prev: any) => ({
      ...prev,
      [type]: allData
    }));
  };

  console.log('allData', filter)

  const onClearAll = (type: string) => {
    setFilter((prev: any) => ({
      ...prev,
      [type]: null
    }));
  };

  const handleChange = (value: string[]) => {
    console.log(value);
    if (value.length > 0) {
      setFilter((prev: any) => ({
        ...prev,
        tags: value
      }));
      return;
    }

    setFilter((prev: any) => ({
      ...prev,
      tags: null
    }));
  };

  const onChangePage: PaginationProps['onChange'] = (page) => {
    setCurrentPage(page);
    refetchForums();
  };

  const onChangePageSize: PaginationProps['onShowSizeChange'] = (current, size) => {
    setForumsPerPage(size);
  }

  const onSelectAuthors: GetProp<typeof Checkbox.Group, 'onChange'> = (checkedValues) => {
    setFilter((prev: any) => ({
      ...prev,
      authors: checkedValues
    }));
  };

  const onSelectSubgroups: GetProp<typeof Checkbox.Group, 'onChange'> = (checkedValues) => {
    console.log('checked = ', checkedValues);
    setFilter((prev: any) => ({
      ...prev,
      pilotGroupIds: checkedValues
    }));
  };

  const onSelectCategories: GetProp<typeof Checkbox.Group, 'onChange'> = (checkedValues) => {
    setFilter((prev: any) => ({
      ...prev,
      categories: checkedValues
    }));
  };

  const popOverContent = () => (
    <PopOverWrapper>
      <PopOverItem>
        <div>
          <span>Author</span>
          <div>
            <button onClick={() => onCheckAll('authors')}>All</button>
            <span>|</span>
            <button onClick={() => onClearAll('authors')}>Clear</button>
          </div>
        </div>
        <div className="checkboxes-wrapper">
          <DivWrapper>
            <Checkbox.Group value={filter?.authors ?? []} options={authorsOptions} defaultValue={['']} onChange={onSelectAuthors} />
          </DivWrapper>
        </div>
      </PopOverItem>
      <PopOverItem>
        <div>
          <span>Pilot Groups</span>
          <div>
            <button onClick={() => onCheckAll('pilotGroupIds')}>All</button>
            <span>|</span>
            <button onClick={() => onClearAll('pilotGroupIds')}>Clear</button>
          </div>
        </div>
        <div className="checkboxes-wrapper">
          <DivWrapper>
            <Checkbox.Group value={filter?.pilotGroupIds ?? []} options={communitySubgroupsOptions} defaultValue={['']} onChange={onSelectSubgroups} />
          </DivWrapper>
        </div>
      </PopOverItem>
      <PopOverItem>
        <div>
          <span>Categories</span>
          <div>
            <button onClick={() => onCheckAll('categories')}>All</button>
            <span>|</span>
            <button onClick={() => onClearAll('categories')}>Clear</button>
          </div>
        </div>
        <div className="checkboxes-wrapper">
          <DivWrapper>
            <Checkbox.Group value={filter?.categories ?? []} options={categoriesOptions} defaultValue={['']} onChange={onSelectCategories} />
          </DivWrapper>
        </div>
      </PopOverItem>
    </PopOverWrapper>
  );

  const renderTag = (tagsArray: string[]) => {
    return tags
      ?.filter((tag: TagsType) => tagsArray.includes(tag.id))
      .map((tag: TagsType) => (
        <CommunityTag key={tag.id}>{tag.name}</CommunityTag>
      ));
  };

  const onVisitForumTopic = (id: string) => {
    navigate(`${id}/forum_topics`);
  };

  useEffect(() => {
    if (totalTags) {
      setTagsPerPage(totalTags);
      refetchTags();
    }
  }, [totalTags, refetchTags]);

  if (loadingListCommunitySubgroups || loadingTags) {
    return <CustomLoading />
  }

  console.log('forums', forums)

  return (
    <CommonLayout title="Community" width="90%">
      <FilterActionsWrapper>
        <Select
          mode="multiple"
          allowClear
          style={{ minWidth: 200, maxWidth: 400 }}
          placeholder="Filter by tags"
          onChange={handleChange}
          options={options}
        />
        <Popover placement="bottomRight" content={popOverContent} arrow={false}>
          <StyledButton
            buttonType="primary"
            icon={<MaterialIcon className="material-icons-sharp" icon="filter_alt" style={{ fontSize: 20 }} />}
          >
            Show Only
          </StyledButton>
        </Popover>
        <StyledButton
          onClick={() => setModal((prev) => ({ ...prev, newForum: { ...prev.newForum, open: true } }))}
          buttonType="secondary"
          icon={<MaterialIcon className="material-icons-sharp" icon="add" style={{ fontSize: 16 }} />}
        >
          New Item
        </StyledButton>
      </FilterActionsWrapper>
      {loadingForums ? (
        <Spin />
      ) : (
        <>
          {forums?.length > 0 ? (
            <Flex gap="large" vertical align="center">
              <Flex wrap gap="large" justify="center" style={{ width: '100%' }}>
                {forums.map((forum: ForumTopicType) => (
                  <CommunityCard key={forum.id} onClick={() => onVisitForumTopic(forum.id)} hoverable>
                    <div>
                      <div className="user-info">
                        <AvatarContainer>
                          <Avatar
                            src={forum.attributes.professionalLogoUrl?.trim() ? forum.attributes.professionalLogoUrl : getRandomAvatarUrl()}
                            size={{ xs: 60 }}
                          />
                        </AvatarContainer>
                        <div>
                          <p>{forum.attributes.owner}</p>
                          <p>{forum.attributes.postedAt}</p>
                        </div>
                      </div>
                      <div className="community-image">
                        <Image
                          height={130}
                          src={forum.attributes.coverImageUrl ?? imgPlaceholder}
                        />
                      </div>
                      <div className="community-info">
                        <p className="general-text">General</p>
                        <span className="title">{forum.attributes.title}</span>
                        <p className="category">{forum.attributes.category}</p>
                        <div className="description" dangerouslySetInnerHTML={{ __html: forum.attributes.body }} />
                      </div>
                    </div>
                    <div>
                      <div className="community-tags">
                        {renderTag(forum.attributes.tags)}
                      </div>
                      <Divider />
                      <div className="community-actions">
                        <div className="icon-container">
                          <MaterialIcon
                            className="material-icons-sharp"
                            icon="comment"
                            style={{ fontSize: 'inherit' }}
                          />
                          <span>{forum.attributes.commentCount}</span>
                        </div>
                        <div></div>
                      </div>
                    </div>
                  </CommunityCard>
                ))}
              </Flex>
              <Pagination
                size="small"
                total={totalForums}
                pageSize={forumsPerPage}
                onChange={onChangePage}
                onShowSizeChange={onChangePageSize}
                showSizeChanger
              />
            </Flex>
          ) : (
            <NoDataWrapper>
              <MaterialIcon
                className="material-icons-sharp"
                icon="folder_off"
                style={{ fontSize: '4rem', color: theme.color.primary }}
              />
              <span>No forum topics found.</span>
            </NoDataWrapper>
          )}
        </>
      )}
      <Modal
        title={modal.newForum.title}
        open={modal.newForum.open}
        onCancel={() => setModal((prev) => ({
          ...prev,
          newForum: {
            ...prev.newForum,
            open: false,
          }
        }))}
        footer={null}
        style={{
          pointerEvents: 'auto'
        }}
        width="95%"
      >
        <CommunityForm
          onAfterSubmit={() => {
            setModal((prev) => ({
              ...prev,
              newForum: {
                ...prev.newForum,
                open: false,
              }
            }))
          }}
        />
      </Modal>
    </CommonLayout>
  )
}

export default ProfessionalCommunity